var _style, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLove01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 187.8 187.8",
    style: {
      enableBackground: "new 0 0 187.8 187.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:url(#SVGID_00000052084551409756216210000006584116112695454653_);}\r\n\t.st3{fill:url(#SVGID_00000179630286114290220920000008565998371009509010_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 90.0573,
    cy: 50.6394,
    r: 143.4856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FA627F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4111,
    style: {
      stopColor: "#ED3F5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7791,
    style: {
      stopColor: "#E32541"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E01C38"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 94.6,
    cy: 94.9,
    r: 90.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.6,145.8l-18-11.7c-44-28.5-44-49-44-56.7c0-18.4,14.9-33.2,33.2-33.2c12.3,0,23.1,6.7,28.8,16.7 c5.7-10,16.5-16.7,28.8-16.7c18.4,0,33.2,14.9,33.2,33.2c0,7.7,0,28.3-44,56.7L94.6,145.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove01);
export default __webpack_public_path__ + "static/media/love-01.337aa7299f42b88ff6e2c9c8be77ab5a.svg";
export { ForwardRef as ReactComponent };